import styled from 'styled-components';

export const Container = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  background-color: var(--black);
  color: #fff;

  .error-content {
    max-width: 600px;
    text-align: center;

    h1 {
      font-size: 3rem;
      margin-bottom: 1.5rem;
      color: var(--pink);
    }

    p {
      font-size: 1.8rem;
      margin-bottom: 3rem;
      line-height: 1.6;
    }

    .button {
      display: inline-block;
      padding: 1.2rem 3rem;
      font-size: 1.6rem;
      margin: 0 auto;
    }

    .error-details {
      margin-top: 3rem;
      text-align: left;
      background-color: rgba(255, 255, 255, 0.05);
      padding: 2rem;
      border-radius: 0.8rem;

      summary {
        cursor: pointer;
        font-weight: 500;
        margin-bottom: 1rem;
        color: var(--green);

        &:hover {
          color: var(--pink);
        }
      }

      pre {
        white-space: pre-wrap;
        word-wrap: break-word;
        font-size: 1.2rem;
        line-height: 1.4;
        overflow-x: auto;
      }
    }
  }
`;






